import './lib/audiencePreferences'
import './trust-entry.css'
import { captureInitialCampaign } from './lib/analytics'
import { readPublicRoute } from './lib/publicRoute'
import { initializeStaticDocument } from './lib/staticDocument'
import { initializeSortableTables } from './lib/sortableTable'

captureInitialCampaign(window.location.search)
const route = initializeStaticDocument(readPublicRoute())
initializeSortableTables()

const contactRoot = document.querySelector<HTMLElement>('[data-contact-form]')
const contactLocale = route?.locale
if (contactRoot && contactLocale) {
  void Promise.all([
    import('./components/ContactForm'),
    import('react'),
    import('react-dom/client'),
  ]).then(([
    { ContactForm },
    { StrictMode, createElement },
    { createRoot },
  ]) => {
    createRoot(contactRoot).render(createElement(
      StrictMode,
      null,
      createElement(ContactForm, { locale: contactLocale, previewWhenUnavailable: true }),
    ))
  })
}
